<script>
import Loader from "./loader";

/**
 * Transactions component
 */
export default {
  components: {
    Loader,
  },
  props: {
    datas: {
      type: Array,
      default: function () {
        return [];
      },
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {

    totalPages() {
      return Math.ceil(this.datas.length / this.itemsPerPage);
    },

    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.datas.slice(startIndex, endIndex);
    },
  },
  totalPages() {
    return Math.ceil(this.datas.length / this.itemsPerPage);
  },

  paginatedData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.datas.slice(startIndex, endIndex);
  },
  methods: {
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    }
  }
};
</script>


<template>

  <Loader :loading="updating">
    <!-- Your table code here -->
    <div class="table-responsive mb-0">
      <table class="table align-middle table-nowrap">
        <!-- Table header -->
        <thead class="table-light">
        <tr>
          <th class="align-middle" v-for="column in columns" :key="column.key">
            {{ column.name }}
          </th>
        </tr>
        </thead>
        <!-- Table body -->
        <tbody>


        <tr v-for="data in paginatedData" :key="data.id">
          <td v-for="column in columns" :key="column.key">
            <span v-if="column.key==='updatedAt'">{{ data[column.key] | formatDate }}</span>
            <span v-else-if="column.key==='installmentDate'">{{ data[column.key] | formatDate }}</span>
            <span v-else-if="column.key==='contractDate'">{{ data[column.key] | formatDate }}</span>
            <span v-else-if="column.key==='amount'">{{ moneyFormat(data[column.key]) }}</span>
            <span v-else-if="column.key==='balance'">
                <p v-if="Number(data[column.key])<100" :style="{color:'red',fontWeight:'bold'}">
                    {{ data[column.key] }}
                </p>
                <p v-else>{{ data[column.key] }}</p>
            </span>
            <span v-else>{{ data[column.key] }}</span>
          </td>
        </tr>


        </tbody>
      </table>
    </div>
    <!-- Pagination -->
    <div class="row">
      <div class="col-12">
        <div
            class="dataTables_paginate paging_simple_numbers float-end"
        >
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
                v-if="totalPages > 1"
                v-model="currentPage"
                :total-rows="datas.length"
                :per-page="itemsPerPage"
                class="d-flex justify-content-end"
            ></b-pagination>

          </ul>

        </div>
      </div>

      <div class="col-2  total-pages-content">
        Toplam sayfa sayısı {{ totalPages }}
      </div>

    </div>
  </Loader>

</template>


<style>
.stock .total-pages-content {
  display: none !important;
}

.total-pages-content:first-child {
  display: none;
}

.total-pages-content {
  margin-top: -20px;
}
</style>

